export enum operators {
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not contains',
  EQUALS = 'equals',
  NOT_EQUALS = 'not equals',
  GREATER = 'greater',
  GREATER_EQUALS = 'greater equals',
  LOWER = 'lower',
  LOWER_EQUALS = 'lower equals',
  BETWEEN = 'between',
}

export enum criteria {
  BOX = 'idtrackbox',
  ARTIST = 'artist',
  TITLE = 'title',
  ALBUM = 'album',
  YEAR = 'year',
  BPM = 'bpm',
  PLAYTIME = 'playtime_seconds',
  UPLOAD_DATE = 'upload_date',
  TAGS = 'tags',
}

export interface Criterion {
  field: string;
  operator: operators;
  value: number | string | string[] | object;
}

export function textInput(operator: string): boolean {
  return operator === operators.NOT_CONTAINS || operator === operators.NOT_EQUALS;
}
